<h1 class="title">Action tasks</h1>
<h5>Manually execute maintenance action tasks</h5>

<acabim-card
        [cardContent]="settings"
        [isCollapsible]="true"
        [isCollapsed]="false"
        [hasHelpButton]="true"
        helpMessage="Tick to manually execute maintenance action tasks in the background,
        i.e. auto-generate work orders from maintenance schedules, etc.
        This is a super-admin privilege function."
        cardHeading="Execute scheduled tasks">
</acabim-card>

<ng-template #settings>
    <p-toast key="superTasks" position="top-center" life="3000"></p-toast>
    <form class="cas-flex-column cas-form-floating">
        <acabim-form-block labelWidth="18" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
            <acabim-form-input-wrapper>
                <acabim-form-input-label class="buttoned">Run action schedule tasks for ACABIM</acabim-form-input-label>
                <acabim-form-input-content [mediumField]="true">
                    <button class="cas-button-action" (click)="runActions()">Run tasks</button>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>
    </form>
</ng-template>

